import React from 'react';
import Component from '@/Component';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class ModifyTime extends Component {

  onChangeHour(e) {
    this.props._updateModifyTimeHour(e.target.value)
  }

  onChangeMinute(e) {
    this.props._updateModifyTimeMinute(e.target.value)
  }

  onClickDelete() {
    this.props._deleteModifyTime();
  }

  onClickSave() {
    this.props._saveModifyTime();
  }

  render() {
    const {
      type,
      isOpen,
      hour,
      minute,
      modified,
      _closeModifyTime,
    } = this.props;

    return (
      <div>
        <Modal isOpen={isOpen} toggle={_closeModifyTime} backdrop="static" centered={true}>
          <ModalHeader toggle={_closeModifyTime}>{type === 'first' ? "최초":"최종"}시간 수정</ModalHeader>
          <ModalBody>
            <div className="input-group" style={{display: 'flex'}}>
              <input type="number" className="form-control" value={hour} onChange={this.onChangeHour} min="0" max="14" />
              <span style={{margin: 5}}>시 </span>
              <input type="number" className="form-control" value={minute} onChange={this.onChangeMinute} min="0" max="59" />
              <span style={{margin: 5}}>분</span>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="default" onClick={_closeModifyTime}>Close</Button>
            {modified ? <Button color="danger" onClick={this.onClickDelete}>Delete</Button> : null}
            <Button color="primary" onClick={this.onClickSave}>Save</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default ModifyTime;




// WEBPACK FOOTER //
// ./src/components/main/ModifyTime.js